export default {
  isAuthorized: false,
  role_id: null,
  permissions: [],
  notification: false,
};
